/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { UpdateUserKYCOptions, UpdateUserKYCResponses } from '../types/UpdateUserKYC'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Set or clear a user's KYC completion timestamp
 * {@link /v1/integrators/user/:user_id/kyc}
 */
export function updateUserKYC<ThrowOnError extends boolean = true>(
  options: Options<UpdateUserKYCOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateUserKYCResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/integrators/user/{user_id}/kyc',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateUserKYCResponses, ThrowOnError>>,
  )
}
